/**
 * A same-tab signal that the calendar changed - specifically, that some
 * event's remind_at may now exist, or have moved, in a way that
 * CalendarReminderToasts has not seen yet.
 *
 * That toast component only re-fetches on mount, tab focus, or this event.
 * Without it, creating or editing an event from CalendarPage in the SAME
 * tab would leave its reminder unarmed until the tab happens to regain
 * OS-level focus again - React Router navigation never fires a native
 * focus/visibilitychange event, so in one continuous session that could be
 * never. Firing this the moment a save completes closes that gap.
 */
const EVENT_NAME = 'cgtodo:calendar-events-changed';

export function notifyCalendarEventsChanged(): void {
  window.dispatchEvent(new Event(EVENT_NAME));
}

/** Returns an unsubscribe function, for use in a useEffect cleanup. */
export function onCalendarEventsChanged(handler: () => void): () => void {
  window.addEventListener(EVENT_NAME, handler);
  return () => window.removeEventListener(EVENT_NAME, handler);
}
